import { render, staticRenderFns } from "./MessageViewport.vue?vue&type=template&id=63615da2&scoped=true"
import script from "./MessageViewport.vue?vue&type=script&lang=js"
export * from "./MessageViewport.vue?vue&type=script&lang=js"
import style0 from "./MessageViewport.vue?vue&type=style&index=0&id=63615da2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63615da2",
  null
  
)

export default component.exports